import React from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { useNavigate } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const DetalleAnularCitaMedicaModal = ({ open, onClose, onError }) => {
  const navigate = useNavigate();
  if (!open) return null;

  return (
    <FlexContainer
      className={'pos-fixed justify-center align-items-center'}
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className={'pos-rel flex-column align-center m-format90 width-600px padtb36 padlr36'}
        style={{
          background: '#ffffff',
          borderRadius: '6px 6px 6px 6px',
          boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
        }}
      >
        <FlexContainer
          onClick={onClose}
          className={
            'pos-abs top20 right20 pointer width-34px height-34px align-items-center justify-center text-18 fontWhite'
          }
          style={{
            borderRadius: '50%',
            background: '#023B7A',
            fontWeight: '900',
            boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div
          className={
            'width-520px m-format90 height-420px bgWhite borderrad20 padtb20 padlr12 pos-rel top16 margb20 left30 m-left0'
          }
        >
          {' '}
          <Label className={'text-18 font-bold text-center'} style={{ color: '#023B7A' }}>
            <strong>Anulación exitosa</strong>
          </Label>
          <FlexContainer
            className={
              'justify-center align-center margl160 m-margl60 margt28 pos-rel width-180px height-180px'
            }
            style={{
              borderRadius: '50%',
              border: '4px solid #023B7A',
            }}
          >
            <FlexContainer
              className={
                'justify-center align-center flex-column margt14 width-140px height-140px '
              }
              style={{
                borderRadius: '50%',
                background: '#6f8ec0',
                padding: '5px',
              }}
            >
              <Label className={'text-20 font-semibold text-center'} style={{ color: '#023B7A' }}>
                <strong>¡Listo!</strong>
              </Label>

              <Label
                className={'text-14 text-center margt6'}
                style={{
                  color: '#023B7A',
                  lineHeight: '1.4',
                  fontWeight: 600,
                }}
              >
                Tu cita ha sido
                <br />
                anulada <br /> con éxito.
              </Label>
            </FlexContainer>

            <FlexContainer
              className={
                'justify-center align-center width-40px height-40px right0 bottom4 pos-abs'
              }
              style={{
                borderRadius: '50%',
                background: '#023B7A',
                border: '4px solid #ffff',
              }}
            >
              <span
                className={'text-24 fontWhite margt8'}
                style={{ fontWeight: 900, lineHeight: 1 }}
              >
                <strong>✓</strong>
              </span>
            </FlexContainer>
          </FlexContainer>
          <Label
            className={'text-14 padlr50 margt28 text-center'}
            style={{
              color: '#4B4B4B',
              width: '80%',
              lineHeight: '1.4',
            }}
          >
            Recuerda que puedes{' '}
            <strong>
              volver a<br /> agendar a una cita{' '}
            </strong>
            cuando gustes.
          </Label>
          <FlexContainer className={'justify-center gap-22 margt32'}>
            <button
              className={'padtb12 padlr22 text-12 borderrad8 bgTransparent pointer'}
              style={{
                border: '2px solid #023B7A',
                color: '#023B7A',
                fontWeight: 600,
              }}
              onClick={() => {
                onClose();
                navigate('/');
              }}
            >
              VOLVER AL INICIO
            </button>
            {/*<button
              className={
                'padtb12 padlr22 text-12 borderrad8  pointer borderNone'
              }
              style={{
                background: '#6f8ec0',
                color: '#023B7A',
                fontWeight: 600,
              }}
              onClick={onError}
            >
              AGENDAR UNA NUEVA CITA
            </button>*/}
          </FlexContainer>
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default DetalleAnularCitaMedicaModal;
